document.addEventListener("DOMContentLoaded", function(){
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  let variantSelected = urlParams.get("variant");

  let stockNumberDiv = document.querySelector(".product__stock-number");
  let stockNumber = document.querySelector("#product__stock-number__id");
  let stockInput = document.querySelector("#stock_number_ga");
  let variantAdditionalData = JSON.parse(document.querySelector('#additionalVariantMetafieldData').textContent);
  let variantAdditionalDataArray = Object.entries(variantAdditionalData);

  if (variantSelected != null) {
     //Loop through variant data and find stock number to display
     variantAdditionalDataArray.forEach(prod => {
      if(prod[1].metafields != undefined) {
        if(prod[0] == variantSelected && prod[1].metafields.stock_number != undefined ) {
          if(stockNumberDiv.classList.contains("hidden")) {
            stockNumberDiv.classList.remove("hidden");
          }
          stockNumber.innerHTML = prod[1].metafields.stock_number;
          stockInput.value = prod[1].metafields.stock_number;
        }
      }
    });
  }

  //Listen for URL mutations, grab new ?variant= when one is selected
  let observer = new MutationObserver(function(mutations) {
    if (window.location.search !== queryString) {
      queryString = window.location.search;
      urlParams = new URLSearchParams(queryString);
      variantSelected = urlParams.get("variant");

      //Redefine these variables, as the golden child may have changed and reloaded the elements
      stockNumberDiv = document.querySelector(".product__stock-number");
      stockNumber = document.querySelector("#product__stock-number__id");
      stockInput = document.querySelector("#stock_number_ga");
      variantAdditionalData = JSON.parse(document.querySelector('#additionalVariantMetafieldData').textContent);
      variantAdditionalDataArray = Object.entries(variantAdditionalData);

      variantAdditionalDataArray.forEach(prod => {
        if(prod[1].metafields != undefined) {
          if(prod[0] == variantSelected) {
            if(prod[1].metafields.stock_number && prod[1].metafields.stock_number != undefined  ) {
              if(stockNumberDiv.classList.contains("hidden")) {
                stockNumberDiv.classList.remove("hidden");
              }
              stockNumber.innerHTML = prod[1].metafields.stock_number;
              stockInput.value = prod[1].metafields.stock_number ;
            }
            else {
              if(!stockNumberDiv.classList.contains("hidden")) {
                stockNumberDiv.classList.add("hidden");
              }
              stockNumber.innerHTML = "";
              stockInput.value = "" ;
            }
          }
        }
      });
    }
  });

  let config = {subtree: true, childList: true};
  observer.observe(document, config);
});